import { render, staticRenderFns } from "./UiTalentPicker.vue?vue&type=template&id=70031c4a"
import script from "./UiTalentPicker.vue?vue&type=script&lang=ts"
export * from "./UiTalentPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports